<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">Legal</div>
    </template>

    <div class="grey lighten-3" style="height: 100%">
      <v-list class="py-0 rounded-lg">
        <menu-item :to="{ name: 'legal/referrer' }" title="Referrer Terms of Service" />

        <v-divider/>
        
        <menu-item :to="{ name: 'legal/privacy' }" title="Privacy Policy" />

        <v-divider/>
        
        <menu-item :to="{ name: 'legal/w-9-cert' }" title="W-9 Certification" />
      </v-list>
    </div>
  </ContentPage>
</template>

<script>
import { ContentPage, MenuItem } from '@/components/pages'
import { mapActions } from 'vuex'

export default {
  name: "YouLegalMenuView",

  components: { ContentPage, MenuItem },

  methods: {
    ...mapActions('auth', ['loadMe']),
  },

  created() {
    this.loadMe()
  }
}
</script>